import React from 'react';
import { Trans } from 'react-i18next';

import colours from '../../../../Common/DesignSystem/Colours';

import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import { P2Bold } from '../../../../Common/DesignSystem/Text';

export const EmptyState = () => (
	<div
		data-testid="geolocation-empty-state"
		className="gps-devices-empty-state"
	>
		<Icon name="Vehicle" size={20} />
		<P2Bold style={{ color: colours.primary.grey01 }}>
			<Trans>No vehicles to show</Trans>
		</P2Bold>
	</div>
);